import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/ucenter/my-advice.vue'
wx.createPage(MiniProgramPage)